/* eslint-disable */
<template>
  <div class="my-4 ma-md-5 mx-lg-12">
    <v-row
      no-gutters
      v-bind:class="[
        'mx-2 align-center',
        {
          'flex-column justify-center': !$vuetify.breakpoint.mdAndUp,
        },
      ]"
    >
    </v-row>
    <template>
      <h2 class="titleMobile">{{ $t('views.utils.title') }}</h2>
      <div class="plantillaUtils">
        <v-row>
          <v-col cols="12">
            <p class="description"
            :style="{marginTop: '1rem'}">{{ $t('views.utils.description') }} </p>
          </v-col>
        </v-row>

        <v-row>
          <v-col :style="{display: 'flex', flexDirection: 'column', gap: '1rem'}">
            <!-- REMOTO -->
            <v-card class="btn-card"
              :style="{padding: '1rem', marginLeft: '1rem', marginRight: '3rem',
              background: '#e6f1ee'}"
              href="https://proyectotelemaco.es/"
              target="_blank"
              rel="noopener noreferrer">
              <div :style="{display: 'flex', flexDirection: 'column', gap: '1rem'}">
                <div :style="{display: 'flex', justifyContent: 'space-between'}">
                  <h3>{{ $t('views.configuration.remoto.title') }}</h3>
                  <v-icon
                  :style="{color: '#27846d !important', fontSize: '26px'}"
                    >
                    mdi-chevron-right
                  </v-icon>
                </div>
                <p>{{  $t('views.configuration.remoto.description') }}</p>
              </div>
            </v-card>
            <!-- ACORTADOR -->
            <v-card class="btn-card"
            :style="{padding: '1rem', marginLeft: '1rem', marginRight: '3rem',
            background: '#e6f1ee'}"
            to="/utils/shortener">
            <div :style="{display: 'flex', flexDirection: 'column', gap: '1rem'}">
              <div :style="{display: 'flex', justifyContent: 'space-between'}">
                <h3>{{ $t('views.utils.acortador.title') }}</h3>
                <v-icon
                :style="{color: '#27846d !important', fontSize: '26px'}"
                  >
                  mdi-chevron-right
                </v-icon>
              </div>
              <p>{{  $t('views.utils.acortador.description') }}</p>
            </div>
          </v-card>
          <!-- CONVERSOR TELEFONICO -->
          <v-card class="btn-card"
          :style="{padding: '1rem', marginLeft: '1rem', marginRight: '3rem',
          background: '#e6f1ee'}"
          to="/utils/converter">
            <div :style="{display: 'flex', flexDirection: 'column', gap: '1rem'}">
              <div :style="{display: 'flex', justifyContent: 'space-between'}">
                <h3>{{ $t('views.utils.conversor.title') }}</h3>
                <v-icon
                :style="{color: '#27846d !important', fontSize: '26px'}"
                >
                  mdi-chevron-right
                </v-icon>
              </div>
              <p>{{  $t('views.utils.conversor.description') }}</p>
            </div>
          </v-card>
          <!-- GENERADOR QR -->
          <v-card class="btn-card"
            :style="{padding: '1rem', marginLeft: '1rem', marginRight: '3rem',
            background: '#e6f1ee'}"
            to="/utils/generateqr">
            <div :style="{display: 'flex', flexDirection: 'column', gap: '1rem'}">
              <div :style="{display: 'flex', justifyContent: 'space-between'}">
                <h3>{{ $t('views.utils.qr.title') }}</h3>
                <v-icon
                :style="{color: '#27846d !important', fontSize: '26px'}"
                  >
                  mdi-chevron-right
                </v-icon>
              </div>
              <p>{{  $t('views.utils.qr.description') }}</p>
            </div>
          </v-card>

          <!-- VALIDADOR DNI -->

          <v-card class="btn-card"
            :style="{padding: '1rem', marginLeft: '1rem', marginRight: '3rem',
            background: '#e6f1ee'}"
            href="https://www.midni.gob.es/VerificadorQR"
            target="_blank">
            <div :style="{display: 'flex', flexDirection: 'column', gap: '1rem'}">
              <div :style="{display: 'flex', justifyContent: 'space-between'}">
                <h3>{{ $t('views.utils.validadorDNI.title') }}</h3>
                <v-icon
                :style="{color: '#27846d !important', fontSize: '26px'}"
                  >
                  mdi-chevron-right
                </v-icon>
              </div>
              <p>{{  $t('views.utils.validadorDNI.description') }}</p>
            </div>
          </v-card>
          </v-col>
        </v-row>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'UtilsView',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      hasRoles: 'session/hasRole',
      get: 'globalState/get',
    }),
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
    }),
  },

};
</script>
<style lang="scss" scoped>
$header-padding: 10 0;
  .plantillaUtils {
    background-color: white;
    padding-bottom: 1rem;
    margin-bottom: 1em;
    margin-top: 1em;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 7%),
    0px 2px 2px 0px rgb(0 0 0 / 5%), 0px 1px 5px 0px rgb(0 0 0 / 5%);
  }
  .btn-card:hover {
    border: 1px solid #27846d;
  }
  .description {
    padding: 0;
    margin: 0 2rem;
  }

  @media (max-width: 600px) {

    div.v-slide-group__content {
      flex-wrap: wrap !important;
      width: 100% !important;
      background-color: red;
    }

  }
    @media (max-width: 768px) {
    .titleMobile{
      margin-left: 2rem !important;
    }
  }

</style>
